import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { TabsParamList } from "./ParamsList/TabsParams";
import { Feather } from '@expo/vector-icons';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import HomeStack from "../Home";
import AccountingStack from "../Accounting";
import SettingStack from '../Settings'
import InfoPersoStack from "../InfoPerso";
import AgendaStack from "../Agenda";
import BookingRequestStack from "../BookingRequest";
import Queries from "../../api/queries";
import QueryToken from "../../api/queries/queryToken";
import AchatsStack from "../Achats";


const Tab = createBottomTabNavigator<TabsParamList>();

function Tabs() {
    const { t, i18n } = useTranslation();

    React.useEffect(() => {
        getRoles();
    }, [])

    const [roles, setRoles] = React.useState([]);

    const queries = new Queries();
    const queriesToken = new QueryToken();

    const getRoles = async () => {
        const responseGraphql = await queries.getPrestaInfo()
        const prestaData = responseGraphql.data.getPrestaInfo;
        const graphqlRoles = await queriesToken.getPrestaRoles(prestaData.email);
        const getPrestaRoles = graphqlRoles.data.getPrestaRoles;
        setRoles(getPrestaRoles);
    }

    return (
        <Tab.Navigator
            screenOptions={({ route }) => ({
                headerShown: false,
                tabBarInactiveTintColor: "#000",
                tabBarActiveTintColor: "#D71D9A",
                tabBarIcon: ({ color }) => {
                    let icon = <></>;
                    if (route.name === "Home") {
                        icon = <Feather name="calendar" size={25} color={color} />
                    } else if (route.name == "Accounting") {
                        icon = <MaterialIcons name="euro-symbol" size={25} color={color} />
                    } else if (route.name == "InfoPerso") {
                        icon = <Feather name="info" size={25} color={color} />
                    } else if (route.name === "Settings") {
                        icon = <Feather name="settings" size={25} color={color} />
                    } else if (route.name === "Agenda") {
                        icon = <Feather name="list" size={25} color={color} />
                    } else if (route.name === "Achats") {
                        icon = <Feather name="shopping-cart" size={25} color={color} />
                    } else if (route.name === "Booking") {
                        icon = <Feather name="bookmark" size={25} color={color} />
                    }
                    return icon;
                },
            })}
        >
            {!roles.isSubcontractor &&
                <Tab.Screen
                    name="Accounting"
                    component={AccountingStack}
                    options={{
                        tabBarLabel: t("HEADER_ACCOUNTING"),
                    }}
                />
            }
            <Tab.Screen
                name="Home"
                component={HomeStack}
                options={{
                    tabBarLabel: t("HEADER_HOME"),
                }}
            />
            {roles.isSubcontractor &&
                <Tab.Screen
                    name="Agenda"
                    component={AgendaStack}
                    options={{
                        tabBarLabel: t("HEADER_AGENDA"),
                    }}
                />
            }
            {/* {roles.isCustomer &&
                <Tab.Screen
                    name="Booking"
                    component={BookingRequestStack}
                    options={{
                        tabBarLabel: t("HEADER_BOOKING"),
                    }}
                />
            } */}
            {roles.isSubcontractor && <Tab.Screen
                name="Achats"
                component={AchatsStack}
                options={{
                    tabBarLabel: t("HEADER_ACHATS"),
                }}
            />}
            <Tab.Screen
                name="InfoPerso"
                component={InfoPersoStack}
                options={{
                    tabBarLabel: t("HEADER_INFO"),
                }}
            />
            <Tab.Screen
                name="Settings"
                component={SettingStack}
                options={{
                    tabBarLabel: t("HEADER_SETTING"),
                }}
            />
        </Tab.Navigator>
    );
}

export default Tabs;
